import { BaseModel } from "src/app/shared/models";

export class TaskStatus extends BaseModel {
  task_id: string;
  task_name: string;
  task_type: string;
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED';
  created_at: string;
  updated_at: string;
  read: boolean;
  params: any;
  result: any;

  static fromJson(jsonData: any): TaskStatus {
    return Object.assign(new TaskStatus(), jsonData);
  }

  getMapFields(): Object {
    return {
      task_name: 'Nome'
    };
  }
}


export const getTaskStatusDescription = (status: string): string => {
  switch (status) {
    case 'PENDING': return 'Pendente';
    case 'PROCESSING': return 'Processando';
    case 'COMPLETED': return 'Concluído';
    case 'COMPLETED_WITH_ERRORS': return 'Concluído com erros';
    case 'FAILED': return 'Falhou';
    default: return '';
  }
}
